import Cookie from 'js-cookie';
var ApiService = {
  name: 'api_url',
  get: function get() {
    return Cookie.get(this.name) || null;
  },
  set: function set(url, options) {
    Cookie.set(this.name, url, options);
  },
  remove: function remove() {
    Cookie.remove(this.name);
  }
};
export default ApiService;